import { useMemo } from 'react';
import { Typography, Box } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import './StudentCard.scss';

const StudentCard = ({ student, onAdd }) => {
  const renderStudent = useMemo(() => () => {
    if (student) {
      return (
        <Box
          data-test={`assign-student-student-card-${student.attributes.userName}`}
          className='existing-student-item'
          onClick={() => onAdd(student)}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onAdd(student);
            }
          }}
        >
          <Box display='flex' flexDirection='row'>
            <Box data-test={`assign-student-student-card-${student.attributes.userName}-add-student-action`} className='add-student-item-icon-box'>
              <AddCircleIcon className='add-student-item-icon' />
            </Box>
            <Box className='search-existing-student-box'>
              <div className='search-existing-student-title' data-dd-privacy='mask'>
                {`${student.attributes.firstName} ${student.attributes.lastName}`}
              </div>
              <Typography gutterBottom variant='subtitle1' component='p' className='search-existing-student-subtitle' data-dd-privacy='mask'>
                {student.attributes.userName}
              </Typography>
            </Box>
          </Box>
        </Box>
      );
    } else {
      return null;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student, onAdd]);
  return renderStudent();
};

export default StudentCard;
